import { BackstageOverrides } from '@backstage/core-components';
import { Theme } from '@mui/material/styles';

export const styledMuiBadge = (_: Theme): BackstageOverrides['MuiBadge'] => ({
  root: {
    '& > div': {
      alignItems: 'center',
      display: 'flex',
    },
  },
});
